import { SchemaSection } from '../../../schemas/models/schemaSection';
import {
  suggestComputedFieldPayloadSchema,
  suggestComputedFieldResponseSchema,
} from './suggestComputedField.schema';

export type SuggestComputedFieldPayload = {
  fieldSchemaId: string;
  hint: string;
  schemaContent: SchemaSection[];
  iterative?: boolean;
  queryIndex?: number | null;
};

export type SuggestComputedFieldResult = {
  matching: {
    configuration: Record<string, unknown>;
  };
};

export type SuggestComputedFieldResponse = {
  results: Array<SuggestComputedFieldResult>;
};

export const suggestComputedField = (payload: SuggestComputedFieldPayload) =>
  ({
    endpoint: `internal/schemas/suggest_computed_field`,
    method: 'POST',
    responseSchema: suggestComputedFieldResponseSchema,
    payloadSchema: suggestComputedFieldPayloadSchema,
    payload,
  }) as const;
